import Button from '@material-ui/core/Button';
import _ from 'lodash';
import {
    disableMenuOption,
    enableMenuOption,
    restartMenuOption,
    updateMenuOption,
    useHandleAction,
} from './ActionButtonHelper';
import {
    AGENT_DATA_SOURCE,
    AGENT_STATUS_DISABLED,
    AGENT_STATUS_DOWN,
    AGENT_STATUS_ENABLING,
    AGENT_STATUS_FIELD,
    AGENT_STATUS_RESTART,
    AGENT_STATUS_RUNNING,
    AGENT_STATUS_UPDATE,
} from './AgentConstants';
import { createAlertConfig } from '../../../stores/AlertsStore';
import useUiToasts, { SUCCESS } from '../../../stores/ToastStore';

const buttons = [updateMenuOption, enableMenuOption, disableMenuOption, restartMenuOption];

function isActionDisabled(option, agent) {
    const canPerformAction = {
        [AGENT_STATUS_UPDATE]: (agentStatus) =>
            agentStatus === AGENT_STATUS_RUNNING || agentStatus === AGENT_STATUS_DISABLED,
        [AGENT_STATUS_ENABLING]: (agentStatus) => agentStatus === AGENT_STATUS_DISABLED,
        [AGENT_STATUS_DISABLED]: (agentStatus) =>
            agentStatus === AGENT_STATUS_RUNNING || agentStatus === AGENT_STATUS_DOWN,
        [AGENT_STATUS_RESTART]: (agentStatus) => agentStatus === AGENT_STATUS_RUNNING,
    };

    const buttonAction = _.get(option, `updateObject.${AGENT_STATUS_FIELD}`);
    return !canPerformAction[buttonAction](_.get(agent, AGENT_STATUS_FIELD));
}

export default function AgentDetailActionButtons({ agent, refreshLatestAgentData }) {
    const handleAction = useHandleAction(AGENT_DATA_SOURCE, () => ({}));
    const [, uiToastActions] = useUiToasts();

    const handlePostAction = (menuOption) => {
        return () => {
            refreshLatestAgentData();
            uiToastActions.createToast(createAlertConfig(SUCCESS, menuOption.successMessage));
        };
    };

    const handleActionClick = (menuOption) => {
        return handleAction(menuOption, {}, { selection: [agent._id], inverted: false }, handlePostAction(menuOption));
    };

    return (
        <>
            {buttons.map((option) => (
                <Button
                    key={option.key}
                    onClick={() => handleActionClick(option)}
                    disabled={isActionDisabled(option, agent)}
                >
                    {option.text}
                </Button>
            ))}
        </>
    );
}
